class BobIconStyle {
  static responsiveStyle(bobIconObj: any) {

    return {
      "font-size": `${bobIconObj.size}px !important`,
    }
  }
}

export default BobIconStyle